export default "__VITE_ASSET__JM3sdAuZ__"